import React, { useLayoutEffect } from "react";

const TradingViewTicker = ({ theme = "light" }) => {
  const loadWidget = () => {
    if (typeof window === "undefined") return;

    const container = document.getElementById("tradingview-widget-container");
    if (!container) return;

    const scriptId = "tradingview-widget-script";
    const existingScript = document.getElementById(scriptId);
    if (existingScript) existingScript.remove();

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.async = true;

    script.innerHTML = JSON.stringify({
      symbols: [
        { description: "Reliance Industries", proName: "BSE:RELIANCE" },
        { description: "TCS", proName: "BSE:TCS" },
        { description: "Infosys", proName: "BSE:INFY" },
        { description: "HDFC Bank", proName: "BSE:HDFCBANK" },
        { description: "ICICI Bank", proName: "BSE:ICICIBANK" },
        { description: "State Bank of India", proName: "BSE:SBIN" },
        { description: "Bharti Airtel", proName: "BSE:BHARTIARTL" },
        { description: "Larsen & Toubro", proName: "BSE:LT" },
        { description: "Hindustan Unilever", proName: "BSE:HINDUNILVR" },
        { description: "Bajaj Finance", proName: "BSE:BAJFINANCE" },
        { description: "Kotak Mahindra Bank", proName: "BSE:KOTAKBANK" },
        { description: "Adani Enterprises", proName: "BSE:ADANIENT" },
        { description: "Maruti Suzuki", proName: "BSE:MARUTI" },
        { description: "NTPC", proName: "BSE:NTPC" },
        { description: "UltraTech Cement", proName: "BSE:ULTRACEMCO" },
        { description: "Nestle India", proName: "BSE:NESTLEIND" },
        { description: "Asian Paints", proName: "BSE:ASIANPAINT" },
        { description: "Wipro", proName: "BSE:WIPRO" },
        { description: "Tech Mahindra", proName: "BSE:TECHM" },
        { description: "HCL Technologies", proName: "BSE:HCLTECH" }
      ],
      showSymbolLogo: true,
      isTransparent: true,
      displayMode: "adaptive",
      colorTheme: "light", // Theme is passed as a prop
      locale: "en"
    });
    container.innerHTML = "";
    container.appendChild(script);
  };

  useLayoutEffect(() => {
    loadWidget();
  }, [theme]); 

  return (
    <div id="tradingview-widget-container" style={{ marginTop: "1%",borderTop: '1px solid gray',borderBottom: '1px solid gray', backgroundColor: 'var(--ticker-bg)' }}>
    </div>
  );
};

export default TradingViewTicker;
